import { render, staticRenderFns } from "./ServiceTypeCreate.vue?vue&type=template&id=280d24a8&scoped=true"
import script from "./ServiceTypeCreate.vue?vue&type=script&lang=ts"
export * from "./ServiceTypeCreate.vue?vue&type=script&lang=ts"
import style0 from "./ServiceTypeCreate.vue?vue&type=style&index=0&id=280d24a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d24a8",
  null
  
)

export default component.exports